import Link from 'react-router/lib/Link';
import { mapProps, compose as Compose } from 'recompose';
import {
  assoc,
  dissoc,
  compose,
} from 'ramda';
import withRole from '../auth/utils/withRole';
import { USER_TYPES } from '../auth/constants';
import withActiveType from '../auth/utils/withActiveType';

const stripDispatchProp = props => dissoc('dispatch', props);

const addPrefix = (props) => {
  if (props.role === USER_TYPES.barber) {
    return assoc('to', `/barber${props.to}`, props);
  }

  if (props.type === 'brand') {
    return assoc('to', `/brand${props.to}`, props);
  }

  return props;
};

const propsMapper = compose(stripDispatchProp, addPrefix);

export default Compose(
  withRole,
  withActiveType,
  mapProps(propsMapper),
)(Link);
